import React from "react";
import BingoCard from "../BingoCard/BingoCard";
import { useCardStore } from "../../stores/cardStore";
import "./SelectedCardContainer.css"
import { useGameStateStore } from "../../stores/gameStateStore";


export default function SelectedCardContainer() {
  const selectedCard = useCardStore(c => c.selectedCardandChip).sort((a, b) => a.cardId - b.cardId);
  const pickedNumbers = useGameStateStore(n => n.pickedNumbers);

  return (
    <div className="selected-card-container">
      {
        selectedCard.length === 0
          ? <NoCardSelected />
          : selectedCard.map((card, cI) => {
            return <BingoCard cardId={card.cardId} numbers={card.numbers} key={`selected-card-${cI}`} pickedNumbersInCard={pickedNumbers} />
          })
      }
    </div>
  )
}


const NoCardSelected = React.memo(function NoCardSelected() {
  return (
    <div className="no-card-con">
      <span className="no-card-text">لم يتم اختيار أي بطاقات لهذه الجولة</span>
    </div>
  )
})